import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="#">
                <i className="fa fa-facebook-square" />
              </a>
              <a href='https://www.linkedin.com/in/piyush-singhal-1358b0188/'>
                <i className='fa fa-linkedin'></i>
              </a>
              <a href='https://www.instagram.com/piyush_.singhal/'>
                <i className="fa fa-instagram" />
              </a>
              <a href="#">
                <i className="fa fa-twitter" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text">Piyush Singhal </span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiatic Developer 💻", 
                     1000,
                    "Technical Content Writer ✍️", 
                     1000,
                    "Python Developer 🐍", 
                     1000,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Building Front end websites.
            </span>
          </div>

          <div className="profile-options">
            <button className="btn primary-btn"
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            > Hire Me </button>
            <a href='PIYUSH_SINGHAL_AMITY_NOIDA1.pdf' download='Piyush_Singhal_Resume'>
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
